// @flow
import * as React from 'react';
import { localize } from '@ta/common.i18n';
import ImportantBlockUserInfo from './ImportantBlockUserInfo';
import ListTemplate from './ListTemplate';
import styles from './BlockUserDescriptionContent.less';

type Props = {|
  /** The display name of a profile */
  displayName: string,
|};

const BlockUserDescriptionContent = ({ displayName }: Props) => (
  <React.Fragment>
    <div className={styles.notice} key="notice">
      <span className={styles.notice_text}>
        {/** If you block {displayName}, they will no longer be able to: */}
        {localize('social_block_modal_notice', { displayName })}
      </span>
    </div>
    <div className={styles.list} key="list">
      <ListTemplate>
        {/** Follow you on TripAdvisor */}
        {localize('social_block_modal_ex_follow_v2')}
        {/** Send you direct messages */}
        {localize('social_block_modal_ex_dm')}
        {/** Repost your contributions */}
        {localize('social_block_modal_ex_repost_v2')}
      </ListTemplate>
    </div>
    <div className={styles.additional} key="additional_info">
      <ImportantBlockUserInfo />
    </div>
  </React.Fragment>
);

export default BlockUserDescriptionContent;
